import { z } from "zod";

import { multiSelectResponseSchema } from "../../common/schemaHelper";

/**
 * Eating Habits validation schema
 * Validates the entire eatingHabits category
 */

export const eatingHabitsValidation = z.object({
  mealsAndSnacks: z.string().regex(/\d{1,2}(-\d{1,2}){0,1}/),
  eatingBehaviors: z.array(multiSelectResponseSchema).min(1, "Please select at least one option"),
  foodAndDrink: z.string().min(1),
  eatingDisorders: z.array(multiSelectResponseSchema).min(1, "Please select at least one option"),
});

export default eatingHabitsValidation;
